import { useEffect, useState } from "react";

// Ported from ai-medical-consultation-assistant/src/components/ChunkIndicator.jsx
export default function ChunkIndicator({ chunkCount, isRecording }) {
  const [pulseKey, setPulseKey] = useState(0);

  useEffect(() => {
    if (chunkCount > 0) {
      setPulseKey((k) => k + 1);
    }
  }, [chunkCount]);

  return (
    <div className="chunk-indicator">
      <svg
        className="chunk-indicator__trace"
        viewBox="0 0 160 32"
        width="120"
        height="26"
      >
        <polyline
          points="0,16 28,16 34,4 40,28 46,16 74,16 80,8 86,24 92,16 160,16"
          className={`chunk-indicator__line ${isRecording ? "is-live" : ""}`}
          fill="none"
        />
        {chunkCount > 0 && (
          <circle
            key={pulseKey}
            className="chunk-indicator__blip"
            cx="150"
            cy="16"
            r="3"
          />
        )}
      </svg>
      <div className="chunk-indicator__label">
        {chunkCount === 0 ? (
          <span className="chunk-indicator__muted">No chunks sent yet</span>
        ) : (
          <span>
            Chunk <strong>#{chunkCount}</strong> sent
          </span>
        )}
      </div>
    </div>
  );
}
